import { DomainError } from '../errors/domain-error';
import { slugifyNewsletterPublicationName } from './marketing-access';

export function slugifyNewsletterEditionArchive(title: string): string {
  const slug = slugifyNewsletterPublicationName(title);
  if (!slug) {
    throw new DomainError('Edition title is required for archive slug');
  }
  return slug.slice(0, 80);
}

export function marketingArchivePath(publicationSlug: string, archiveSlug: string) {
  return `/n/${publicationSlug}/p/${archiveSlug}`;
}

export function marketingArchiveIndexPath(publicationSlug: string) {
  return `/n/${publicationSlug}/archive`;
}

export function marketingArchiveRssPath(publicationSlug: string) {
  return `/n/${publicationSlug}/rss.xml`;
}

export function marketingPodcastRssPath(publicationSlug: string) {
  return `/n/${publicationSlug}/podcast.xml`;
}

export function marketingEditionAudioPath(publicationSlug: string, archiveSlug: string) {
  return `/n/${publicationSlug}/p/${archiveSlug}/audio`;
}

export function escapeMarketingFeedXml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** TipTap-compatible doc from plaintext paragraphs for Content dual-publish Lite. */
export function plaintextToArticleBodyJson(plaintext: string) {
  const paragraphs = plaintext
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter(Boolean);
  const content =
    paragraphs.length > 0
      ? paragraphs.map((text) => ({
          type: 'paragraph',
          content: [{ type: 'text', text }],
        }))
      : [{ type: 'paragraph' }];
  return { type: 'doc', content };
}
